export const SET_CODES = "setCodes";
export const SET_FOLDER_NAME_TITLE = "setFolderNameTitle";
export const SET_PRODUCT_LIST = "setProductList";
export const SET_PRODUCT_LIST_COUNT = "setProductListCount";
export const SET_SEARCH_PRODUCT_TYPE = "setSearchProductType";
export const SET_SHOW_PRODUCT_LIST_FOLDER_ID = "setShowProductListFolderId";
export const SET_PAGE_NUMBER = "setPageSize";
export const SET_CURRENT_PAGE = "setCurrentPage";
export const SET_DOCUMENT_ADD_ITEMS = "setDocumentAddItems";